document.addEventListener("DOMContentLoaded", function () {
  const swiperWrapper = document.querySelector(
    ".logolist_slider .swiper-wrapper"
  );
  const slide = swiperWrapper.querySelector(".swiper-slide");

  if (slide) {
    for (let i = 0; i < 10; i++) {
      let clone = slide.cloneNode(true);
      swiperWrapper.appendChild(clone);
    }
  }

  var swiper = new Swiper(".logolist_slider", {
    slidesPerView: "auto",
    loop: true,
    breakpoints: {
      150: {
        spaceBetween: 10,
      },
      576: {
        spaceBetween: 15,
      },
      769: {
        spaceBetween: 20,
      },
      1025: {
        spaceBetween: 20,
      },
    },
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 8000,
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const MultipleSlider = () => {
    const MultipleSliders = document.querySelectorAll(".prodCardSlider");
    MultipleSliders.forEach((slider, index) => {
      const prevArrow = slider.parentElement.querySelector(".prev");
      const nextArrow = slider.parentElement.querySelector(".next");
      new Swiper(slider, {
        effect: "slide",
        speed: 1000,
        navigation: {
          nextEl: nextArrow,
          prevEl: prevArrow,
        },
        breakpoints: {
          150: {
            slidesPerView: 1.3,
            spaceBetween: 15,
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          769: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          1025: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        },
      });
    });
  };
  MultipleSlider();
});

document.addEventListener("DOMContentLoaded", function () {
  const MultipleSlider = () => {
    const MultipleSliders = document.querySelectorAll(".testiMonialSlider");
    MultipleSliders.forEach((slider, index) => {
      new Swiper(slider, {
        effect: "slide",
        speed: 1000,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          150: {
            slidesPerView: 1.3,
            spaceBetween: 10,
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          769: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          1025: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
      });
    });
  };
  MultipleSlider();
});

document.addEventListener("DOMContentLoaded", function () {
  const MultipleSlider = () => {
    const MultipleSliders = document.querySelectorAll(".WELLNES_PRODUCT");
    MultipleSliders.forEach((slider, index) => {
      const prevArrow = slider.parentElement.querySelector(".prev");
      const nextArrow = slider.parentElement.querySelector(".next");
      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 10,
        speed: 1400,
        parallax: true,
        effect: "slide",
        navigation: {
          nextEl: nextArrow,
          prevEl: prevArrow,
        },
      });
    });
  };
  MultipleSlider();
});

document.addEventListener("DOMContentLoaded", function () {
  const MultipleSlider = () => {
    const MultipleSliders = document.querySelectorAll(".collectionTabSlider");
    MultipleSliders.forEach((slider, index) => {
      const prevArrow = slider.parentElement.querySelector(".prev");
      const nextArrow = slider.parentElement.querySelector(".next");
      new Swiper(slider, {
        slidesPerView: "auto",
        speed: 800,
        effect: "slide",
        navigation: {
          nextEl: nextArrow,
          prevEl: prevArrow,
        },
        breakpoints: {
          150: {
            spaceBetween: 10,
          },
          576: {
            spaceBetween: 10,
          },
          769: {
            spaceBetween: 20,
          },
        },
      });
    });
  };
  MultipleSlider();
});
